// import * as Sentry from '@sentry/react'
// import React from 'react'
// import {
//   createRoutesFromChildren,
//   matchRoutes,
//   useLocation,
//   useNavigationType,
// } from 'react-router-dom'

// import { isProduction } from '@/config/api'
// import { env } from '@/env'
// import { CacheAdapter } from '@/shared/infra'

// if (isProduction) {
//   Sentry.init({
//     dsn: `${env.VITE_SENTRY_DSN}`,
//     enableLogs: true,
//     integrations: [
//       Sentry.reactRouterV6BrowserTracingIntegration({
//         useEffect: React.useEffect,
//         useLocation,
//         useNavigationType,
//         createRoutesFromChildren,
//         matchRoutes,
//       }),
//       Sentry.replayIntegration({
//         maskAllText: false,
//         maskAllInputs: false,
//       }),
//       Sentry.breadcrumbsIntegration({
//         console: true,
//         dom: true,
//         fetch: true,
//         history: true,
//         xhr: true,
//       }),
//       Sentry.consoleLoggingIntegration({ levels: ['log', 'error', 'warn'] }),
//     ],
//     beforeBreadcrumb(breadcrumb) {
//       return breadcrumb.category === 'ui.click' ||
//         breadcrumb.category === 'ui.input'
//         ? null
//         : breadcrumb
//     },
//     beforeSendSpan(span) {
//       try {
//         const userData = CacheAdapter.get('userData')
//         const searchingQuery = CacheAdapter.get('searchingQuery')
//         span.data = {
//           ...span.data,
//           'app.route': window.location.pathname,
//           'app.company_id': searchingQuery?.companyId ?? 0,
//           'user.id': userData?.attributes?.sub ?? 'anon',
//         }
//       } catch (error) {
//         console.error('Error adding data to Sentry span', error)
//       }
//       return span
//     },
//     beforeSend(event, hint) {
//       const original = hint?.originalException as
//         | { name?: string; message?: string }
//         | undefined

//       const frames = event.exception?.values?.[0]?.stacktrace?.frames ?? []

//       if (
//         original?.name === 'NetworkError' &&
//         frames.some((frame) => frame.filename?.includes('amazon-cognito'))
//       ) {
//         console.log('Ignorando erro temporário do Cognito:', original)
//         return null
//       }

//       const hasAppFrame = frames.some(
//         (f) =>
//           (typeof f.filename === 'string' &&
//             (f.filename.includes('/src/') ||
//               f.filename.startsWith('app:///'))) ||
//           (typeof (f as any).abs_path === 'string' &&
//             (f as any).abs_path.includes(window.location.host)),
//       )

//       const errorMessage = original?.message ?? ''
//       const ignoredPatterns = [
//         /chrome-extension/i,
//         /firebase/i,
//         /gtag/i,
//         /google-analytics/i,
//         /Script error/i,
//         /Network request failed/i,
//       ]

//       if (
//         ignoredPatterns.some((pattern) => pattern.test(errorMessage)) &&
//         !hasAppFrame
//       ) {
//         return null
//       }

//       return event
//     },
//     // Set tracesSampleRate to 1.0 to capture 100%
//     // of transactions for performance monitoring.
//     tracesSampleRate: 0.3,
//     // Set `tracePropagationTargets` to all subdomains of b2breservas.com.br
//     tracePropagationTargets: ['https://agency.b2breservas.com.br/'],
//     // Capture Replay for 10% of all sessions,
//     // plus for 100% of sessions with an error
//     replaysSessionSampleRate: 0.1,
//     replaysOnErrorSampleRate: 1.0,
//     denyUrls: [/extensions\//i, /^chrome:\/\//i, /google-analytics\.com/i],
//     ignoreErrors: [
//       "Cannot read properties of null (reading 'postMessage')",
//       'Network error',
//       '"undefined" is not valid JSON',
//       'Unexpected end of JSON input',
//       'QuotaExceededError',
//       /Failed to fetch dynamically imported module.*\.js$/,
//       /error loading dynamically imported module/,
//       'ResizeObserver loop limit exceeded',
//       'Non-Error promise rejection captured with value',
//     ],
//   })
// }

// // Export logger for use throughout the application
// export const { logger } = Sentry

import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://c72e21ecbeed212fe4474d2e14c7d626@o4507504999399424.ingest.us.sentry.io/4510874093027328',
  sendDefaultPii: true,
})
